import * as ActionTypes from '../../actions'
import {
    Action, TrafficCongestion
} from "../../types";
import areaChartConfig from '../../highchartsConfigDefault/areaChartConfig';

const defaultState = {
    allDay: {
        isLoading: true,
        hasError: false,
        chart: {}
    }
};

export default function(state: TrafficCongestion = defaultState, action: Action) {
    const { type, payload, meta } = action;
    let key = 'allDay';
    if (meta) {
        key = meta
    }

    switch (type) {
        case ActionTypes.FETCH_TRAFFIC_CONGESTION: {
            // const value = state[key];

            const nextValue = {
                isLoading: true,
                hasError: false,
            };

            return {
                ...state,
                [key]: nextValue,
            };
        }
        case ActionTypes.FETCH_TRAFFIC_CONGESTION_SUCCESS: {
            const { areaChart } = payload;
            const { series } = areaChart;
            // const value = state[key];

            const nextValue = {
                // ...value,
                isLoading: false,
                hasError: false,
                chart: {
                    area: {
                        config: areaChartConfig().initializeWithOptions({
                            chart: {
                                height: '345px'
                            },
                            series,
                            tooltip: {
                                enabled: true
                            }
                        }),
                        show: true
                    }
                }
            };

            return {
                ...state,
                [key]: nextValue,
            };
        }
        case ActionTypes.FETCH_TRAFFIC_CONGESTION_MESSAGE: {
            const { congestion_measure, ts } = payload;
            const key = meta;
            const currentState = state[key];

            if (currentState) {

                const chart = currentState.chart;
                const area = chart.area;
                const series = area.config.series;
                let seriesData = series[0].data;
                const seriesPoint = {
                    x: ts * 1000, y: congestion_measure
                };

                seriesData.push(seriesPoint);


                const nextValue = {
                    // ...value,
                    isLoading: false,
                    hasError: false,
                    chart: {
                        area: {
                            config: areaChartConfig().initializeWithOptions({
                                chart: {
                                    height: '345px'
                                },
                                series,
                                tooltip: {
                                    enabled: true
                                }
                            }),
                            show: true
                        }
                    }
                };


                return {
                    ...state,
                    [key]: nextValue

                }
            }

            return state;
        }
        case ActionTypes.FETCH_TRAFFIC_CONGESTION_FAILURE: {
            // const value = state[key];

            const nextValue = {
                // ...value,
                isLoading: false,
                hasError: true
            };

            return {
                ...state,
                [key]: nextValue,
            };
        }
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dashboard/trafficCongestion.ts